
import { defineComponent } from 'vue';
import EdModal from './EdModal.vue';
import { ModalControl } from '@/parts/ModalControl';

export default defineComponent({
  name: 'ModalTrigger',
  components: {
    EdModal,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  setup() {
    const control = new ModalControl();
    return {
      control,
      show: control.showModal,
    };
  },
});
